export default "__VITE_ASSET__Bexldd6M__"